<template>
  <v-card elevation="0">
    <!-- <v-card-text> -->
      <v-card class="d-flex items-center justify-center" 
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"      
        :elevation="dragover ? 20 : 2"
        style="transition: all .2s ease-in-out cursor: pointer"
      >
        <v-card-text>
          <slot />

        </v-card-text>
        <!-- <v-icon style="font-size: 17em" x-large>mdi-cloud-upload</v-icon> -->
      </v-card>
    <!-- </v-card-text> -->
  </v-card>
</template>

<script>
export default {
  data: () => ({
    dragover: false
  }),
  methods:{
    onDrop(e){
      this.dragover = false

      this.$emit('change', e.dataTransfer.files[0])
      // console.log(e.dataTransfer.files[0])
      
      // if (!this.multiple && e.dataTransfer.files.length > 1) {
      //   this.$store.dispatch("addNotification", {
      //     message: "Only one file can be uploaded at a time..",
      //     colour: "error"
      //   });
      // } else e.dataTransfer.files.forEach(element =>
      //     this.uploadedFiles.push(element)
      //   );
    }
  }
}
</script>